import { requst } from '../config'

// 日历上数据
export const getReceiveCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/receive/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getReceiveDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 获取所有 r 文件列表
export const getPreplotRListApi = projectId => {
    const url = `/setting/preplot/getReceiveList/${projectId}`
    return requst.get(url)
}

// 查询日期
export const getReceiveByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/receive/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getReceiveByIdApi = id => {
    const url = `/monitor/receive/${id}`
    return requst.get(url)
}

// 获取 Activities 数据
export const getReceiveActivitiesDataApi = id => {
    const url = `/monitor/receive/activity/list?receiveId=${id}`
    return requst.get(url)
}

// 提交 Receive 总结
export const postReceiveCommentApi = commentData => {
    const url = `/monitor/receive`
    return requst.post(url, { ...commentData })
}

// 修改 Receive 总结
export const putReceiveCommentApi = (commentData, id) => {
    const url = `/monitor/receive`
    return requst.put(url, { ...commentData, id })
}

// 提交 Receive 数据
export const postReceiveActivitiesDataApi = (activitiesParams, id) => {
    const url = `/monitor/receive/activity/addOrUpdateBatch/${id}`
    return requst.post(url, activitiesParams)
}

// 获取 Receive 总炮数据
export const postReceiveAllShotsApi = (shotsParams) => {
    const url = `/monitor/receive/activity/calculateFLPTotal`
    return requst.post(url, shotsParams)
}

